// removed by extract-text-webpack-plugin
module.exports = {"DeliverySummary":"DeliverySummary__DeliverySummary__1fPVa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeliverySummary/DeliverySummary.css
// module id = 242
// module chunks = 1